import { BASE } from '../types';
export default {
  type: BASE,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/base',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
